"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActivePath = void 0;
function isActivePath(input) {
    if (typeof window === 'undefined')
        return false;
    if (!input)
        return false;
    var windowPath = removeTrailingSlash(window.location.pathname) || '/';
    var navLinkPath = removeTrailingSlash(input) || '/';
    /** ---------- handle US route ------------------------ */
    // case for US home
    if (windowPath === '/' && navLinkPath === '/us')
        return true;
    if (windowPath === '/us' && navLinkPath === '/')
        return true;
    // compare US route with no region
    if (windowPath.startsWith('/us/')) {
        // /us/design => /design
        windowPath = windowPath.replace('/us/', '/');
    }
    if (navLinkPath.startsWith('/us/')) {
        navLinkPath = navLinkPath.replace('/us/', '/');
    }
    /** ---------- handle US route ------------------------ */
    // is active path if they are exactly the same
    if (windowPath === navLinkPath)
        return true;
    // windowPath: '/us/design/2022/FF91NA', navPath: '/us/design' => true
    if (windowPath.startsWith(navLinkPath)) {
        // handle home pages, windowPath: '/ar/product/ff-91-Alliance/', navPath: '/ar/' => false
        var homePages = ['/cn', '/ar', '/ar/en'];
        if (homePages.includes(navLinkPath)) {
            return false;
        }
        return true;
    }
    return false;
}
exports.isActivePath = isActivePath;
function removeTrailingSlash(str) {
    return str.replace(/\/+$/, '');
}
